import React from 'react';
import './AboutUs.css';

import { PageTitle } from '../../../components';
import { About, Testimonials, Counter, Team, Services, WhyChooseUs, Banner, Process, Partners, Pricing, NewsletterSection } from '../../../sections';



const AboutUs = () => {

  return (
    <>

      {/* Page title */}
      <PageTitle title={'about us'} page={'about us'} />

      <section className='about-us'>

        <About />
        <Team />
        <NewsletterSection />
        <Partners />

      </section>

    </>
  );
}

export default AboutUs;